import React from 'react';
import { Button } from '../components/UI/Button';
import { Users, Lightbulb, Bot, Video, Calendar, FileText, UserPlus, Globe, Award, Clock, Check, AlertTriangle, MessageSquare } from 'lucide-react';
export const Membership = () => {
  return <div className="pt-20 bg-white" data-id="element-3895">
      {/* Hero Section */}
      <section className="relative py-20 border-b border-gray-200" data-id="element-3896">
        <div className="absolute inset-0 z-0" data-id="element-3897">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bNxF5qHdCS6UJLX4hcirCA/IMG_7209.jpg" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-3898" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-3899"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3900">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3901">
            <div className="inline-block bg-white text-gray-800 px-4 py-1 rounded-full text-sm font-bold mb-6" data-id="element-3902">
              LIMITED TIME OFFER
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-3903">
              The Inner Circle Membership
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-3904">
              Join The Networking Salon Inner Circle — a curated community of
              ambitious professionals. Build meaningful relationships, polish
              your ideas, and unlock opportunities.
            </p>
            <Button className="text-lg px-8 py-4" data-id="element-3905">
              Join Today for ₦20,000 (Founder's Offer)
            </Button>
          </div>
        </div>
      </section>
      {/* Announcement Section */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3906">
        <div className="container mx-auto px-4" data-id="element-3907">
          <div className="max-w-3xl mx-auto border-2 border-dashed border-gray-400 rounded-lg p-8 text-center" data-id="element-3908">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6" data-id="element-3909">
              Special Founder's Offer
            </h2>
            <div className="flex flex-col md:flex-row justify-center gap-8 mb-6" data-id="element-3910">
              <div data-id="element-3911">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3912">Regular Price:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3913">₦50,000/year</p>
              </div>
              <div className="md:border-l md:border-gray-300 md:pl-8" data-id="element-3914">
                <p className="text-lg text-gray-600 mb-2" data-id="element-3915">Founder's Offer:</p>
                <p className="text-3xl font-bold text-gray-800" data-id="element-3916">₦20,000/year</p>
                <p className="text-gray-600 italic" data-id="element-3917">(until Dec 31 only)</p>
              </div>
            </div>
            <div className="bg-gray-100 p-4 rounded-lg" data-id="element-3918">
              <p className="text-gray-700" data-id="element-3919">
                Subscriptions officially begin Jan 1, 2025 — join now and get
                December free.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3920">
        <div className="container mx-auto px-4" data-id="element-3921">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3922">
            Membership Benefits
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-3923">
            {[{
            title: 'Mastermind Sessions',
            description: 'Live idea feedback & strategy polishing',
            icon: <Lightbulb size={24} data-id="element-3924" />
          }, {
            title: 'Project Handholding',
            description: 'Step-by-step guidance',
            icon: <Users size={24} data-id="element-3925" />
          }, {
            title: 'AI Tools Catalogue',
            description: 'Curated tools + playbooks',
            icon: <Bot size={24} data-id="element-3926" />
          }, {
            title: 'Virtual Networking Salons',
            description: 'Free & unlimited for members',
            icon: <Video size={24} data-id="element-3927" />
          }, {
            title: 'Discounted Access to Live Events',
            description: 'Special pricing for Inner Circle members',
            icon: <Calendar size={24} data-id="element-3928" />
          }, {
            title: 'Exclusive Resource Hub',
            description: 'Templates & toolkits',
            icon: <FileText size={24} data-id="element-3929" />
          }, {
            title: 'Mentorship & Expert Access',
            description: 'Group coaching & hot-seat sessions',
            icon: <UserPlus size={24} data-id="element-3930" />
          }, {
            title: 'Visibility & Collaboration Opportunities',
            description: 'Connect with other members',
            icon: <Globe size={24} data-id="element-3931" />
          }].map((benefit, index) => <div key={index} className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-3932">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-3933">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-3934">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-3935">{benefit.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Community Structure */}
      <section className="py-16 bg-gray-50 border-b border-gray-200" data-id="element-3936">
        <div className="container mx-auto px-4" data-id="element-3937">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3938">
            Event & Community Structure
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3939">
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3940">
              <div className="flex items-center mb-4" data-id="element-3941">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3942">
                  <MessageSquare size={24} data-id="element-3943" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3944">
                  WhatsApp Groups
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3945">
                <p className="text-gray-600 mb-4" data-id="element-3946">
                  Reserved exclusively for physical event attendees only.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3947">
                  <li data-id="element-3948">Event-specific discussions</li>
                  <li data-id="element-3949">Limited-time access</li>
                  <li data-id="element-3950">City-based connections</li>
                </ul>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3951">
              <div className="flex items-center mb-4" data-id="element-3952">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mr-4" data-id="element-3953">
                  <Users size={24} data-id="element-3954" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-3955">
                  Inner Circle Membership
                </h3>
              </div>
              <div className="border-l-2 border-gray-300 pl-4 ml-6" data-id="element-3956">
                <p className="text-gray-600 mb-4" data-id="element-3957">
                  Ongoing access to our premium community resources.
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2" data-id="element-3958">
                  <li data-id="element-3959">Regular masterminds</li>
                  <li data-id="element-3960">Virtual salons</li>
                  <li data-id="element-3961">Exclusive resources</li>
                  <li data-id="element-3962">Ongoing opportunities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Lifetime Access */}
      <section className="py-16 border-b border-gray-200" data-id="element-3963">
        <div className="container mx-auto px-4" data-id="element-3964">
          <div className="max-w-3xl mx-auto border-2 border-gray-300 rounded-lg p-8" data-id="element-3965">
            <div className="flex items-center justify-center mb-6" data-id="element-3966">
              <Award size={36} className="text-gray-700 mr-3" data-id="element-3967" />
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-3968">
                Lifetime Access Notice
              </h2>
            </div>
            <p className="text-gray-600 text-lg text-center mb-6" data-id="element-3969">
              As a thank-you, everyone who has ever paid for past Networking
              Salon events now has Lifetime Inner Circle Access — which includes
              all membership benefits (masterminds, resources, AI tools, and
              virtual salons).
            </p>
            <div className="flex items-start bg-gray-100 p-4 rounded-lg border border-gray-300" data-id="element-3970">
              <AlertTriangle size={24} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-3971" />
              <p className="text-gray-700" data-id="element-3972">
                <span className="font-bold" data-id="element-3973">Clarification:</span> Lifetime
                Access does not include free entry to Live physical events.
                Tickets must still be purchased separately.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-3974">
        <div className="container mx-auto px-4" data-id="element-3975">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12" data-id="element-3976">
            Choose Your Membership
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-3977">
            {/* Lifetime Inner Circle Access */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-3978">
              <div className="absolute top-0 right-0 bg-gray-800 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-3979">
                EXCLUSIVE
              </div>
              <div className="flex justify-center mb-6" data-id="element-3980">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3981">
                  <Award size={32} className="text-gray-700" data-id="element-3982" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-3983">
                Lifetime Inner Circle Access
              </h3>
              <p className="text-center text-gray-600 mb-6" data-id="element-3984">
                💎 Exclusive for Past Event Attendees
              </p>
              <div className="border-t border-b border-gray-300 py-4 mb-6" data-id="element-3985">
                <p className="text-center text-gray-700 font-medium" data-id="element-3986">
                  One-time gift for loyalty
                </p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-3987">
                <li className="flex items-start" data-id="element-3988">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3989" />
                  <span className="text-gray-600" data-id="element-3990">
                    All Inner Circle membership benefits
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3991">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3992" />
                  <span className="text-gray-600" data-id="element-3993">Masterminds & resources</span>
                </li>
                <li className="flex items-start" data-id="element-3994">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3995" />
                  <span className="text-gray-600" data-id="element-3996">
                    AI tools & virtual salons
                  </span>
                </li>
                <li className="flex items-start text-gray-700 bg-gray-100 p-2 rounded" data-id="element-3997">
                  <AlertTriangle size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-3998" />
                  <span data-id="element-3999">
                    Does NOT include free entry to Live physical events
                  </span>
                </li>
              </ul>
              <div className="bg-gray-200 text-center p-3 rounded-lg mb-6" data-id="element-4000">
                <span className="font-bold text-gray-700" data-id="element-4001">
                  You're Already In!
                </span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-4002">
                Already a Lifetime Member? Claim Your Access
              </Button>
            </div>
            {/* Founder's Offer */}
            <div className="border-2 border-gray-700 rounded-lg p-8 relative scale-105 shadow-lg" data-id="element-4003">
              <div className="absolute -top-4 -right-4 bg-gray-800 text-white px-4 py-2 text-sm font-bold rounded-lg transform rotate-6" data-id="element-4004">
                BEST VALUE
              </div>
              <div className="flex justify-center mb-6" data-id="element-4005">
                <div className="w-16 h-16 border-2 border-gray-700 rounded-full flex items-center justify-center" data-id="element-4006">
                  <Clock size={32} className="text-gray-700" data-id="element-4007" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-4008">
                Founder's Offer
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-4009">
                🔥 Available Until Dec 31, 2024
              </p>
              <div className="text-center mb-6" data-id="element-4010">
                <p className="text-3xl font-bold text-gray-800" data-id="element-4011">₦20,000</p>
                <p className="text-gray-600" data-id="element-4012">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-4013">
                <li className="flex items-start" data-id="element-4014">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4015" />
                  <span className="text-gray-600" data-id="element-4016">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4017">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4018" />
                  <span className="text-gray-600" data-id="element-4019">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4020">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4021" />
                  <span className="text-gray-600" data-id="element-4022">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4023">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4024" />
                  <span className="text-gray-600" data-id="element-4025">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-4026">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4027" />
                  <span className="text-gray-600" data-id="element-4028">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6" data-id="element-4029">
                <span className="font-medium text-gray-700" data-id="element-4030">
                  Bonus: Subscription officially starts Jan 1, 2025 (December
                  free!)
                </span>
              </div>
              <Button className="w-full" data-id="element-4031">Join Now at ₦20,000</Button>
            </div>
            {/* Standard Membership */}
            <div className="border-2 border-gray-300 rounded-lg p-6 relative" data-id="element-4032">
              <div className="absolute top-0 right-0 bg-gray-600 text-white px-3 py-1 text-sm font-bold rounded-bl-lg" data-id="element-4033">
                REGULAR PRICE
              </div>
              <div className="flex justify-center mb-6" data-id="element-4034">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-4035">
                  <Users size={32} className="text-gray-700" data-id="element-4036" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-gray-800 mb-2" data-id="element-4037">
                Standard Membership
              </h3>
              <p className="text-center text-gray-600 mb-4" data-id="element-4038">
                📌 From Jan 1, 2025
              </p>
              <div className="text-center mb-6" data-id="element-4039">
                <p className="text-3xl font-bold text-gray-800" data-id="element-4040">₦50,000</p>
                <p className="text-gray-600" data-id="element-4041">per year</p>
              </div>
              <ul className="space-y-3 mb-8" data-id="element-4042">
                <li className="flex items-start" data-id="element-4043">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4044" />
                  <span className="text-gray-600" data-id="element-4045">
                    Masterminds & handholding
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4046">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4047" />
                  <span className="text-gray-600" data-id="element-4048">
                    AI Tools Catalogue + Resource Hub
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4049">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4050" />
                  <span className="text-gray-600" data-id="element-4051">
                    Free Virtual Networking Salons
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4052">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4053" />
                  <span className="text-gray-600" data-id="element-4054">Discounted Live Events</span>
                </li>
                <li className="flex items-start" data-id="element-4055">
                  <Check size={20} className="text-gray-700 mr-2 mt-0.5 flex-shrink-0" data-id="element-4056" />
                  <span className="text-gray-600" data-id="element-4057">Exclusive Opportunities</span>
                </li>
              </ul>
              <div className="bg-gray-100 text-center p-3 rounded-lg mb-6 invisible" data-id="element-4058">
                <span data-id="element-4059">Spacer</span>
              </div>
              <Button variant="outline" className="w-full" data-id="element-4060">
                Join for ₦50,000
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-20 bg-gray-50" data-id="element-4061">
        <div className="container mx-auto px-4 text-center" data-id="element-4062">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto" data-id="element-4063">
            Stop Collecting Contacts. Start Building Connections That Change
            Your Future.
          </h2>
          <Button className="text-lg px-8 py-4" data-id="element-4064">
            Join Now for ₦20,000 (Founder's Rate)
          </Button>
          <p className="mt-6 text-gray-600" data-id="element-4065">
            Offer ends December 31, 2024. Regular price ₦50,000/year from
            January 1, 2025.
          </p>
        </div>
      </section>
    </div>;
};